import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { toastError, toastSuccess, exhibitionActionId, sponsorshipTypeActionId } from "../../../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import Pagination from "../../../../../utils/pagination";
import { fill_action } from '../../../../../actions/fillCombo_action';
import { getSponsershipDetails_action, insertSponsorshipInterest_action, deleteSponsorshipMaster_action, getSponsorshipMasterDetails_action, insertUpdateSponsorshipMaster_action } from "../../../../../actions/exhibitor_module_actions/sponsorship_action/sponsorship_action"
import Resizer from "react-image-file-resizer";

class SponsorshipMaster extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            ExihibitionID: '',
            sponsorShipList: [],
            sponsorshipTypeId: '',
            sponsorshipTypeIdErr: '',
            sponsorshipTypeList: [],
            totalQty: '',
            totalQtyErr: '',
            devAs: '',
            devAsErr: '',
            pdfCommon: 1,
            SponsorshipTypeName: '',
            isAU: false,
            devAsPDFPath: '',
            devAsPDFtype: '',
            devAsPDFName: '',
            devAsPDFFile: '',
            devAsPDFErr: '',
            devAsPDFDeleted: true,
            devAsItemPath: '',
            devAsItemtype: '',
            devAsItemName: '',
            devAsItemFile: '',
            devAsItemErr: '',
            devAsItemDeleted: true,
            devAsItemList: [{
                itemName: '',
                itempdfPath: '',
                itempdftype: '',
                itempdfName: '',
                itempdfFile: '',
                itempdfDeleted: true,
            }],
            AvailableQty: '',
            AvailableQtyErr: '',
            AmountINR: '',
            AmountINRErr: '',
            AmountUSD: '',
            AmountUSDErr: '',
            devAsItemListErr: '',
            isExh: false,
            isVis: false,
            userErr: '',
            status: true,
            SponsorshipHdrID: '',
            ExihibitionID: '',
            deleteID: '',
            isOpen: false,
        }
        this.inputvalue = this.inputvalue.bind(this)
        this.onCrossClick = this.onCrossClick.bind(this)
    }

    componentDidMount() {
        this.setState({
            ExihibitionID: this.props.location.state.ExihibitionID != undefined ? (this.props.location.state != null && this.props.location.state.ExihibitionID != null ? this.props.location.state.ExihibitionID : '') : this.props.id != null && this.props.id != undefined ? this.props.id : '',
        })
        setTimeout(() => {
            console.log(this.state.ExihibitionID)
            this.getFillList(sponsorshipTypeActionId, '', '', '', '', '');
            this.getSponsershipDetails()
        }, 200);
    }

    getSponsershipDetails() {
        this.setState({ isLoading: true })
        this.props.getSponsershipDetails_action(this.state.ExihibitionID)
            .then((data) => {
                if (data.error != 1) {
                    if (data.data != '') {
                        setTimeout(() => {
                            this.setState({
                                sponsorShipList: data.data[0],
                                // sponsorshipList: sponsorshipList,
                                isLoading: false
                            });
                        }, 100);
                    }
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    getSponsershipMasterDetails() {
        this.setState({ isLoading: true })
        this.props.getSponsorshipMasterDetails_action(this.state.ExihibitionID, this.state.SponsorshipHdrID, this.state.sponsorshipTypeId)
            .then((data) => {
                if (data.error != 1) {
                    if (data.data != '') {
                        if (data.data[0][0].DeliverableCommonPdfPath != null && data.data[0][0].DeliverableCommonPdfPath != '') {
                            var filePath = data.data[0][0].DeliverableCommonPdfPath
                            var array = data.data[0][0].DeliverableCommonPdfPath != null &&
                                data.data[0][0].DeliverableCommonPdfPath != "" && filePath.split("/")
                            const FileName = array[array.length - 1]
                            console.log('filePath', filePath)
                            this.setState({
                                devAsItemPath: filePath,
                                devAsItemName: FileName,
                                devAsItemDeleted: false,
                            })
                        }
                        if (data.data[0][0].DeliverablePdfPath != null && data.data[0][0].DeliverablePdfPath != '') {
                            var filePath = data.data[0][0].DeliverablePdfPath
                            var array = data.data[0][0].DeliverablePdfPath != null &&
                                data.data[0][0].DeliverablePdfPath != "" && filePath.split("/")
                            const FileName = array[array.length - 1]
                            console.log('filePath', filePath)
                            this.setState({
                                devAsPDFPath: filePath,
                                devAsPDFName: FileName,
                                devAsPDFDeleted: false,
                            })
                        }
                        var list = []
                        for (var i = 0; i < data.data[1].length; i++) {
                            if (data.data[1][i].SponsorshipHdrID == data.data[0][0].SponsorshipHdrID) {
                                var filePath = ''
                                var FileName = ''
                                if (data.data[1][i].DeliverablePDFDoc != null && data.data[1][i].DeliverablePDFDoc != '') {
                                    filePath = data.data[1][i].DeliverablePDFDoc
                                    var array = data.data[1][i].DeliverablePDFDoc != null &&
                                        data.data[1][i].DeliverablePDFDoc != "" && filePath.split("/")
                                    FileName = array[array.length - 1]
                                    console.log('filePath', filePath)
                                }
                                list.push({
                                    itemName: data.data[1][i].DeliverableName,
                                    itempdfPath: filePath,
                                    itempdftype: '',
                                    itempdfName: FileName,
                                    itempdfFile: '',
                                    itempdfDeleted: true,
                                })
                            }
                        }
                        // if (list.length == 0) {
                        //     this.setState({
                        //         devAsItemList: ,
                        //     })
                        // }
                        setTimeout(() => {
                            this.setState({
                                sponsorshipTypeId: data.data[0][0].SponsorshipTypeID,
                                totalQty: data.data[0][0].TotalQty,
                                devAs: data.data[0][0].IsDeliverableAsPDF ? 1 : 2,
                                pdfCommon: data.data[0][0].IsDeliverableCommonPdf ? 1 : 2,

                                devAsItemList: list.length == 0 ? [{
                                    itemName: '',
                                    itempdfPath: '',
                                    itempdftype: '',
                                    itempdfName: '',
                                    itempdfFile: '',
                                    itempdfDeleted: true,
                                }] : list,
                                AvailableQty: data.data[0][0].AvailableQty,
                                AmountINR: data.data[0][0].AmountINR,
                                AmountUSD: data.data[0][0].AmountUSD,
                                isExh: data.data[0][0].IsShowToExhibitor,
                                isVis: data.data[0][0].IsShowToVisitor,
                                status: data.data[0][0].SponsorshipStatusID == 1,
                                // sponsorShipList: data.data[0],
                                // sponsorshipList: sponsorshipList,
                                isLoading: false
                            });
                        }, 100);
                    }
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    getFillList(actionID, ExihibitionID, moduleID, keyValue, value, exhRegistrationID) {
        const { stallAreaId } = this.state
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, ExihibitionID, moduleID, keyValue, value, exhRegistrationID)
            .then((data) => {
                if (data.error != 1) {
                    //exhibition
                    if (actionID === sponsorshipTypeActionId) {
                        console.log("country data", data.data)
                        // var internationalCountryData = data.data.length > 0 && data.data.filter((item) => item.Code != "91")
                        this.setState({
                            sponsorshipTypeList: data.data
                        })
                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    updateItem(item) {
        this.setState({ currentPage: item });
    }




    onFilePick = async (e, file, key, i) => {
        e.preventDefault()
        const { exhibitDetailsList, tempFilePath, devAsItemList } = this.state
        console.log("File01010101------", file, key)
        const { } = this.state
        // console.log(file, document.getElementById(`file${i}`), tempFilePath)
        if (file.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
                    file[0]['name'].toString().toLowerCase().includes('.png') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpg')
                ) {

                    if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
                    ) {
                        image = await this.resizeFile(file[0]);
                        if (key == 1) {
                            this.setState({
                                devAsPDFName: file[0]['name'].toString(),
                                devAsPDFFile: image,
                            })
                        }
                        if (key == 2) {
                            this.setState({
                                devAsItemName: file[0]['name'].toString(),
                                devAsItemFile: image,
                            })
                        }
                        if (key == 3) {
                            devAsItemList[i].itempdfFile = image
                            devAsItemList[i].itempdfName = file[0]['name'].toString()
                            this.setState({
                                // devAsItemList: file[0]['name'].toString(),
                                devAsItemList: devAsItemList,
                            })
                        }

                    }
                    else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
                        image = await this.onPdfSelect(file[0]);
                        if (key == 1) {
                            this.setState({
                                devAsPDFName: file[0]['name'].toString(),
                                devAsPDFFile: image,
                            })
                        }
                        if (key == 2) {
                            this.setState({
                                devAsItemName: file[0]['name'].toString(),
                                devAsItemFile: image,
                            })
                        }
                        if (key == 3) {
                            devAsItemList[i].itempdfFile = image
                            devAsItemList[i].itempdfName = file[0]['name'].toString()
                            this.setState({
                                // devAsItemList: file[0]['name'].toString(),
                                devAsItemList: devAsItemList,
                            })
                        }
                    }

                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")
                    }
                    // if (sessionStorage.getItem('VisitorTypeID') == 2) {
                    //     visitorGroupList[i].passportFileType = fileTypeList.length > 0 ? fileTypeList[1] : ""
                    //     this.setState({ visitorGroupList: visitorGroupList })
                    // } else {
                    if (key == 1) {
                        this.setState({
                            devAsPDFtype: fileTypeList.length > 0 ? fileTypeList[1] : "",
                            //  this.setState({})
                            devAsPDFErr: ''
                        })
                    }
                    if (key == 2) {
                        this.setState({
                            devAsItemtype: fileTypeList.length > 0 ? fileTypeList[1] : "",
                            devAsItemErr: ''
                        })
                    }
                    if (key == 3) {
                        devAsItemList[i].itempdftype = fileTypeList.length > 0 ? fileTypeList[1] : ""
                        this.setState({
                            devAsItemList: devAsItemList,
                            devAsItemErr: ''
                        })
                    }
                    // document.getElementById(`file${i}`).value = document.getElementById(`file${i}`).value

                    // this.setState({ passportFileType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
                    // }

                } else {
                    toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')

                    // if (key == 1) {
                    //     this.setState({ passportFile: "" })
                    //     document.getElementById("passportFile").value = ""
                    // } else if (key == 2) {
                    //     this.setState({ visitorLetterFile: "" })
                    //     document.getElementById("visitorLetter").value = ""
                    // }
                }
            }
        } else {
        }
    }

    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });

    onCrossClick(key, i) {
        console.log(key, i)
        if (key == 1) {
            this.setState({
                devAsPDFPath: '',
                devAsPDFtype: '',
                devAsPDFName: '',
                devAsPDFFile: '',
                // devAsPDFErr: '',
                devAsPDFDeleted: true,
            })
            // document.getElementById("path").value = ""
        } else if (key == 2) {
            this.setState({
                devAsItemPath: '',
                devAsItemtype: '',
                devAsItemName: '',
                devAsItemFile: '',
                // devAsItemErr: '',
                devAsItemDeleted: true,
            })
            // document.getElementById("path2").value = ""
        }
        else if (key == 3) {
            this.state.devAsItemList[i].itempdfPath = ''
            this.state.devAsItemList[i].itempdftype = ''
            this.state.devAsItemList[i].itempdfName = ''
            this.state.devAsItemList[i].itempdfFile = ''
            this.state.devAsItemList[i].itempdfDeleted = true
            this.setState({
                devAsItemList: this.state.devAsItemList,
            })
            // document.getElementById("path2").value = ""
        }

    }
    insertUpdateSponsorshipMaster() {
        const { isLoading, HostName, isAU, PortNo, totalQty, sponsorshipTypeId,
            sponsorshipTypeList, sponsorShipList, UserName, Password, exh_CC, exh_BCC,
            devAsPDFPath,
            devAsPDFtype,
            devAsPDFName, devAsPDFDeleted, AvailableQty, AmountINR, AmountUSD,
            devAsPDFFile, isExh,
            isVis,
            devAsItemPath, devAs,
            devAsItemtype,
            devAsItemName, SponsorshipHdrID,
            devAsItemFile,
            devAsItemDeleted,
            devAsItemList, status, SponsorshipTypeName,
            totalQtyErr, ExihibitionID,
            AvailableQtyErr,
            AmountINRErr,
            userErr, pdfCommon,
            devAsErr,
            devAsPDFErr,
            devAsItemListErr,
        } = this.state
        var err = false
        if (sponsorshipTypeId == "" || sponsorshipTypeId == null) {
            this.setState({
                sponsorshipTypeIdErr: "Please Select Sponsorship Type",
            });
            err = true
        }
        if (totalQty == "" || totalQty == null) {
            this.setState({
                totalQtyErr: "Please Enter Total Quantity",
            });
            err = true
        }
        if (AvailableQty == "" || AvailableQty == null) {
            this.setState({
                AvailableQtyErr: "Please Enter Available Quantity",
            });
            err = true
        }
        if (AmountINR == "" || AmountINR == null) {
            this.setState({
                AmountINRErr: "Please Enter Amount INR",
            });
            err = true
        }
        if (isExh == false && isVis == false) {
            this.setState({
                userErr: "Please Select Atleast 1 User",
            });
            err = true
        }
        if (devAs == "" || devAs == null) {
            this.setState({
                devAsErr: "Please Select Deliverable type",
            });
            err = true
        } else {
            if (devAs == 1) {
                if (devAsPDFName == '' || devAsPDFName == null) {
                    this.setState({
                        devAsPDFErr: "Please Enter PDF",
                    });
                    err = true
                }
            } else if (devAs == 2) {
                for (var i = 0; i < devAsItemList.length; i++) {
                    if (devAsItemList[i].itemName == '') {
                        this.setState({ devAsItemListErr: 'Please Enter all Item Names' })
                        err = true
                    }
                }
                if (pdfCommon == 1) {
                    if (devAsItemName == '' || devAsItemName == null) {
                        this.setState({
                            devAsItemErr: "Please Enter Common Pdf",
                        });
                        err = true
                    }
                } else {
                    for (var i = 0; i < devAsItemList.length; i++) {
                        if (devAsItemList[i].itempdfName == '' || devAsItemList[i].itempdfName == null) {
                            this.setState({ devAsItemListErr: "Please Enter all Pdf" })
                            err = true
                        }
                    }
                }
            }
        }
        var typeName = ''

        sponsorshipTypeList.map(item => {
            if (item.SponsorshipTypeID == sponsorshipTypeId) {
                typeName = item.SponsorshipTypeName
            }
        })
        devAsItemList.map(item => {
            // if (item.SponsorshipTypeID == sponsorshipTypeId) {
            item.SponsorshipHdrID = this.state.SponsorshipHdrID
            //     typeName = item.SponsorshipTypeName
            // }
        })
        console.log(
            devAsPDFPath,
            devAsPDFtype,
            devAsPDFName,
            devAsPDFFile,
            devAsPDFErr,
            // devAsPDFDeleted: true,
            devAsItemPath,
            devAsItemtype,
            devAsItemName,
            devAsItemFile.length,
            // devAsItemErr,
            '[][][[][', '<>',
            SponsorshipHdrID, '<>', ExihibitionID, '<>', sponsorshipTypeId, '<>', totalQty, '<>', AvailableQty, '<>', AmountINR, '<>', AmountUSD, '<>', devAs == 1, '<>', devAs == 2 ? pdfCommon == 1 : false, '<>', devAsItemPath, '<>', isExh, '<>', isVis, '<>', status ? 1 : 2, '<>', devAsPDFFile.length, '<>', devAsPDFtype, '<>', devAsPDFPath, '<>', typeName, '<>', devAsItemFile, '<>', devAsItemtype, '<>', devAsItemList
        )

        if (!err) {
            this.setState({ isLoading: true })
            this.props.insertUpdateSponsorshipMaster_action(SponsorshipHdrID, ExihibitionID, sponsorshipTypeId, totalQty, AvailableQty, AmountINR, AmountUSD, devAs == 1, devAs == 2 ? pdfCommon == 1 : false, devAsItemPath, isExh, isVis, AvailableQty == 0 || AvailableQty == null || AvailableQty == '' ? 2 : status ? 1 : 2, devAsPDFFile, devAsPDFtype, devAsPDFPath, typeName, devAsItemFile, devAsItemtype, devAsItemList)
                .then((data) => {
                    if (data.error != 1) {
                        toastSuccess("Updated successfully!")
                        this.getSponsershipDetails()
                        this.setState({
                            isAU: true,
                            sponsorshipTypeId: '',
                            sponsorshipTypeIdErr: '',
                            totalQty: '',
                            totalQtyErr: '',
                            devAs: '',
                            devAsErr: '',
                            pdfCommon: 1,
                            SponsorshipTypeName: '',
                            devAsPDFPath: '',
                            devAsPDFtype: '',
                            devAsPDFName: '',
                            devAsPDFFile: '',
                            devAsPDFErr: '',
                            devAsPDFDeleted: true,
                            devAsItemPath: '',
                            devAsItemtype: '',
                            devAsItemName: '',
                            devAsItemFile: '',
                            devAsItemErr: '',
                            devAsItemDeleted: true,
                            devAsItemList: [{
                                itemName: '',
                                itempdfPath: '',
                                itempdftype: '',
                                itempdfName: '',
                                itempdfFile: '',
                                itempdfDeleted: true,
                            }],
                            AvailableQty: '',
                            AvailableQtyErr: '',
                            AmountINR: '',
                            AmountINRErr: '',
                            AmountUSD: '',
                            AmountUSDErr: '',
                            devAsItemListErr: '',
                            isExh: false,
                            isVis: false,
                            userErr: '',
                            status: true,
                        })
                        this.setState({
                            isAU: false,
                            isLoading: false
                        })
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })

        } else {
            toastError("Please fill mendetory feilds")
            this.setState({ isLoading: false })
        }
    }

    inputvalue(value, i) {
        this.state.devAsItemList[i].itemName = value
        this.setState({ devAsItemList: this.state.devAsItemList })
    }

    onDelete(i) {
        const { } = this.state
        this.setState({ deleteID: i })
        this.setState({ isOpen: true, })
    }

    deleteSponsorshipMaster(id) {
        console.log(id)
        this.setState({ isLoading: true })
        this.props.deleteSponsorshipMaster_action(this.state.ExihibitionID, id)
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data)
                    this.setState({ isLoading: false, deleteID: '' })
                    toastSuccess("deleted successfully")
                    setTimeout(() => {
                        this.getSponsershipDetails()
                    }, 200);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
                this.setState({ isOpen: false })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    render() {
        const { isLoading, HostName, isAU, PortNo, totalQty, sponsorshipTypeId,
            sponsorshipTypeList, sponsorShipList, typeOfSponsorship, UserName, Password, exh_CC, exh_BCC,
            devAsPDFPath,
            devAsPDFtype, isOpen,
            devAsPDFName, devAsPDFDeleted, AvailableQty, AmountINR, AmountUSD,
            devAsPDFFile, isExh,
            isVis,
            devAsItemPath,
            devAsItemtype,
            devAsItemName,
            devAsItemFile,
            devAsItemDeleted,
            devAsItemList, status,
            totalQtyErr,
            AvailableQtyErr,
            AmountINRErr,
            userErr,
            devAsErr,
            devAsPDFErr,
            devAsItemListErr,
            devAsItemErr, devAs
        } = this.state
        console.log(devAs, '/////')
        return (
            <>

                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <AdminDrawer />


                    <div className="main-container">
                        <div className="exb-topp">
                            {!isAU && <div className="row m-0 mb-2">

                                <div className="col-xl-12 mt-4">
                                    <div
                                        className="mb-1"
                                        aria-label="Basic example"
                                        style={{ float: "right" }}
                                    >
                                        <button type="button" className="btn btn-aqua mt-1"
                                            onClick={e => this.setState({
                                                isAU: true,
                                                sponsorshipTypeId: '',
                                                sponsorshipTypeIdErr: '',
                                                totalQty: '',
                                                totalQtyErr: '',
                                                devAs: '',
                                                devAsErr: '',
                                                pdfCommon: 1,
                                                SponsorshipTypeName: '',
                                                devAsPDFPath: '',
                                                devAsPDFtype: '',
                                                devAsPDFName: '',
                                                devAsPDFFile: '',
                                                devAsPDFErr: '',
                                                devAsPDFDeleted: true,
                                                devAsItemPath: '',
                                                devAsItemtype: '',
                                                devAsItemName: '',
                                                devAsItemFile: '',
                                                devAsItemErr: '',
                                                devAsItemDeleted: true,
                                                devAsItemList: [{
                                                    itemName: '',
                                                    itempdfPath: '',
                                                    itempdftype: '',
                                                    itempdfName: '',
                                                    itempdfFile: '',
                                                    itempdfDeleted: true,
                                                }],
                                                AvailableQty: '',
                                                AvailableQtyErr: '',
                                                AmountINR: '',
                                                AmountINRErr: '',
                                                AmountUSD: '',
                                                AmountUSDErr: '',
                                                devAsItemListErr: '',
                                                isExh: false,
                                                isVis: false,
                                                userErr: '',
                                                status: true,
                                            })}
                                        >
                                            Add
                                        </button>
                                    </div>
                                </div>

                            </div>}
                            <div className="row p-2 mx-2">
                                {isAU ? <>
                                    <div style={{ width: '50%' }}>
                                        <div className="col-md-12 p-0">
                                            <label>Sponsorship type</label>
                                            <select className="form-control"
                                                value={sponsorshipTypeId}
                                                onChange={(e) => this.setState({ sponsorshipTypeId: e.target.value, sponsorshipTypeIdErr: '' })}  >
                                                <option value={''}>Select</option>
                                                {
                                                    sponsorshipTypeList.length > 0 && sponsorshipTypeList.map(data => (
                                                        <option value={data.SponsorshipTypeID} key={data.SponsorshipTypeID}>{data.SponsorshipTypeName}</option>
                                                    ))
                                                }
                                            </select>
                                            {
                                                <span className="text-danger text-start text-left d-block mt-1">
                                                    {this.state.sponsorshipTypeIdErr}
                                                </span>
                                            }
                                        </div><br></br>
                                        <div className="row">
                                            <div className="col-md-6 ">
                                                <label htmlFor="validationCustom03">Total Quantity<span class="required">*</span></label>
                                                <input className="form-control"
                                                    value={totalQty}
                                                    onChange={(e) => this.setState({ totalQty: e.target.value, totalQtyErr: '' })}
                                                    type="number" />
                                                {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                        {this.state.totalQtyErr}
                                                    </span>
                                                }
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="validationCustom03">Avialable Quantity<span class="required">*</span></label>
                                                <input className="form-control"
                                                    value={AvailableQty}
                                                    onChange={(e) => this.setState({ AvailableQty: e.target.value, AvailableQtyErr: '' })}
                                                    type="number" />
                                                {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                        {this.state.AvailableQtyErr}
                                                    </span>
                                                }
                                            </div>
                                        </div>
                                        <div className="row mt-2">
                                            <div className="col-md-6 ">
                                                <label htmlFor="validationCustom03">Amount INR<span class="required">*</span></label>
                                                <input className="form-control"
                                                    value={AmountINR}
                                                    onChange={(e) => this.setState({ AmountINR: e.target.value, AmountINRErr: '' })}
                                                    type="number" />
                                                {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                        {this.state.AmountINRErr}
                                                    </span>
                                                }
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="validationCustom03">Amount USD</label>
                                                <input className="form-control"
                                                    value={AmountUSD}
                                                    onChange={(e) => this.setState({ AmountUSD: e.target.value })}
                                                    type="number" />
                                            </div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-md-6">
                                                <label htmlFor="validationCustom03">User<span class="required">*</span></label>
                                                <label>
                                                    <input type="checkbox" name="exh" value={this.state.isExh}
                                                        checked={this.state.isExh}
                                                        onClick={e => this.setState({ isExh: !isExh, userErr: '' })} /> Exhibitor
                                                </label>
                                                <label>
                                                    <input type="checkbox" name="vis" value={this.state.isVis}
                                                        checked={this.state.isVis}
                                                        onClick={e => this.setState({ isVis: !isVis, userErr: '' })} /> Visitor
                                                </label>
                                            </div>
                                            {
                                                <span className="text-danger text-start text-left d-block mt-1">
                                                    {this.state.userErr}
                                                </span>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <label htmlFor="validationCustom03">Deliverable Type<span class="required">*</span></label>
                                        <label>
                                            <input type="radio" name="DevAs" value={this.state.devAs}
                                                checked={this.state.devAs == 1}
                                                onClick={e => this.setState({ devAs: 1, devAsErr: '' })} /> Deliverable as PDF
                                        </label>
                                        <label>
                                            <input type="radio" name="DevAs" value={this.state.devAs}
                                                checked={this.state.devAs == 2}
                                                onClick={e => this.setState({ devAs: 2, devAsErr: '' })} /> Deliverable as Item
                                        </label>
                                        {
                                            <span className="text-danger text-start text-left d-block mt-1">
                                                {this.state.devAsErr}
                                            </span>
                                        }
                                    </div><br></br>
                                    {this.state.devAs == 1 ?
                                        <>
                                            <label htmlFor="validationCustom03" className="mt-3">
                                                Upload Deliverable Attachment
                                            </label>
                                            <div className="box">
                                                {devAsPDFDeleted == false || devAsPDFName != '' ? <div style={{
                                                    border: '1px solid #ccc',
                                                    padding: '10px',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    // marginTop: '10px'
                                                }}>
                                                    {/* {console.log(this.state.isSSifile)} */}
                                                    {devAsPDFDeleted == false ? <a
                                                        href={devAsPDFPath}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <span style={{ marginRight: '10px' }}
                                                        >{devAsPDFName}</span>
                                                    </a> : <span
                                                    //  onClick={() => this.renderNewImage(devAsPDFFile, devAsPDFtype)} style={{ marginRight: '10px', cursor: 'pointer' }}
                                                    >{devAsPDFName}</span>}
                                                    <i className={`fa fa-times text-danger img-can`}
                                                        onClick={() => this.onCrossClick(1)}
                                                    // onClick={(e) => this.onChapterDocDelete(data.ChapterID, index)}
                                                    ></i>
                                                </div>
                                                    : <div className="upload-options mt-1">
                                                        <label style={{ display: 'flex' }}>
                                                            <input
                                                                type="file"
                                                                id="path"
                                                                // ref={this.fileInputRef}
                                                                name='path'
                                                                className="image-upload"
                                                                accept=".jpg, .jpeg, .png, .pdf"
                                                                onChange={e => this.onFilePick(e, e.target.files, 1)}
                                                            // disabled={isView}
                                                            />
                                                            {
                                                                devAsPDFFile != "" &&
                                                                <i class="fa fa-times text-danger img-can"
                                                                    onClick={() => this.onCrossClick(1)}
                                                                ></i>
                                                            }
                                                        </label>
                                                    </div>}
                                                {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                        {this.state.devAsPDFErr}
                                                    </span>
                                                }
                                            </div>

                                        </>
                                        : this.state.devAs == 2 ?
                                            <div className="row m-0 mb-2" style={{ width: '50%' }}>
                                                <div className="col-md-12 mt-2 p-0">
                                                    <label htmlFor="validationCustom03">Attachment Type<span class="required">*</span></label>
                                                    <label>
                                                        <input type="radio" name="pdfCommon" value={this.state.pdfCommon}
                                                            checked={this.state.pdfCommon == 1}
                                                            onClick={e => this.setState({ pdfCommon: 1 })} /> Common for All items
                                                    </label>
                                                    <label>
                                                        <input type="radio" name="pdfCommon" value={this.state.pdfCommon}
                                                            checked={this.state.pdfCommon == 2}
                                                            onClick={e => this.setState({ pdfCommon: 2 })} /> Different for All items
                                                    </label>
                                                </div>
                                                <div className="col-xl-12 mt-4">
                                                    <div
                                                        className="mb-1"
                                                        aria-label="Basic example"
                                                        style={{ float: "right" }}
                                                    >
                                                        <button type="button" className="btn btn-aqua mt-1"
                                                            onClick={e => {
                                                                devAsItemList.push({
                                                                    itemName: '',
                                                                    itempdfPath: '',
                                                                    itempdftype: '',
                                                                    itempdfName: '',
                                                                    itempdfFile: '',
                                                                    itempdfDeleted: true,
                                                                })
                                                                this.setState({ devAsItemList: devAsItemList })
                                                            }}
                                                        >
                                                            Add Row
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="col-xl-12 mt-4">

                                                    <table class="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0 ">
                                                        <thead class="table-light">
                                                            <tr>
                                                                {/* <th className="text-center">Role ID</th> */}
                                                                <th className="text-center" style={{ width: '50px' }} >Sr no.</th>
                                                                <th className="text-center">Item</th>
                                                                {this.state.pdfCommon == 2 && <th></th>}
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                devAsItemList.length > 0 ? <>{
                                                                    devAsItemList.map((data, i) => (
                                                                        <tr >
                                                                            {/* <td className="text-center">{data.RoleID}</td> */}
                                                                            <td className="text-center">{i + 1}</td>
                                                                            <td className="text-center">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control"
                                                                                    maxLength={'200'}
                                                                                    value={data.itemName}
                                                                                    // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                    onChange={e => this.inputvalue(e.target.value, i)}
                                                                                />
                                                                                {/* <input className="form-control"
                                                                                    value={data.itemName}
                                                                                    onChange={(e) => this.inputvalue(e.target.value, i)
                                                                                        // data.itemName = e.target.value
                                                                                        // this.setState({ devAsItemList: devAsItemList })

                                                                                    }
                                                                                    type="text" /> */}
                                                                            </td>
                                                                            {this.state.pdfCommon == 2 && <td>
                                                                                <div className="box">
                                                                                    {data.itempdfDeleted == false || data.itempdfName != '' ? <div style={{
                                                                                        border: '1px solid #ccc',
                                                                                        padding: '10px',
                                                                                        display: 'inline-flex',
                                                                                        alignItems: 'center',
                                                                                        // marginTop: '10px'
                                                                                    }}>
                                                                                        {/* {console.log(this.state.isSSifile)} */}
                                                                                        {data.itempdfDeleted == false ? <a
                                                                                            href={data.itempdfPath}
                                                                                            target="_blank"
                                                                                            rel="noopener noreferrer"
                                                                                        >
                                                                                            <span style={{ marginRight: '10px' }}
                                                                                            >{data.itempdfName}</span>
                                                                                        </a> : <span
                                                                                        //  onClick={() => this.renderNewImage(devAsPDFFile, devAsPDFtype)} style={{ marginRight: '10px', cursor: 'pointer' }}
                                                                                        >{data.itempdfName}</span>}
                                                                                        <i className={`fa fa-times text-danger img-can`}
                                                                                            // onClick={(e) => this.onChapterDocDelete(data.ChapterID, index)}
                                                                                            onClick={() => this.onCrossClick(3, i)}
                                                                                        ></i>
                                                                                    </div>
                                                                                        : <div className="upload-options mt-1">
                                                                                            <label style={{ display: 'flex' }}>
                                                                                                <input
                                                                                                    type="file"
                                                                                                    id={`path2${i}`}
                                                                                                    // ref={this.fileInputRef}
                                                                                                    name={`path2${i}`}
                                                                                                    className="image-upload"
                                                                                                    accept=".jpg, .jpeg, .png, .pdf"
                                                                                                    onChange={e => this.onFilePick(e, e.target.files, 3, i)}
                                                                                                // disabled={isView}
                                                                                                />
                                                                                                {
                                                                                                    data.itempdfFile != "" &&
                                                                                                    <i class="fa fa-times text-danger img-can"
                                                                                                        onClick={() => this.onCrossClick(3, i)}
                                                                                                    ></i>
                                                                                                }
                                                                                            </label>
                                                                                        </div>}
                                                                                </div>
                                                                            </td>
                                                                            }
                                                                            <td style={{ textAlign: 'center' }}> {devAsItemList.length > 0 && <button
                                                                                type="button"
                                                                                className="btn btn-sm"
                                                                                onClick={() => {
                                                                                    devAsItemList.splice(i, 1)
                                                                                    this.setState({ devAsItemList: devAsItemList })
                                                                                }
                                                                                }
                                                                            >
                                                                                <i className="bi bi-trash text-danger" />
                                                                            </button>}</td>
                                                                        </tr>
                                                                    ))}
                                                                </> :
                                                                    <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                                            }
                                                        </tbody>
                                                    </table>
                                                    {
                                                        <span className="text-danger text-start text-left d-block mt-1">
                                                            {this.state.devAsItemListErr}
                                                        </span>
                                                    }
                                                </div><br></br>
                                                {this.state.pdfCommon == 1 && <>
                                                    <label htmlFor="validationCustom03" className="mt-3">
                                                        Upload Common Item Attachment
                                                    </label>
                                                    <div className="box">
                                                        {devAsItemDeleted == false || devAsItemName != '' ? <div style={{
                                                            border: '1px solid #ccc',
                                                            padding: '10px',
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            // marginTop: '10px'
                                                        }}>
                                                            {/* {console.log(this.state.isSSifile)} */}
                                                            {devAsItemDeleted == false ? <a
                                                                href={devAsItemPath}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                <span style={{ marginRight: '10px' }}
                                                                >{devAsItemName}</span>
                                                            </a> : <span
                                                            //  onClick={() => this.renderNewImage(devAsPDFFile, devAsPDFtype)} style={{ marginRight: '10px', cursor: 'pointer' }}
                                                            >{devAsItemName}</span>}
                                                            <i className={`fa fa-times text-danger img-can`}
                                                                // onClick={(e) => this.onChapterDocDelete(data.ChapterID, index)}
                                                                onClick={() => this.onCrossClick(2)}
                                                            ></i>
                                                        </div>
                                                            : <div className="upload-options mt-1">
                                                                <label style={{ display: 'flex' }}>
                                                                    <input
                                                                        type="file"
                                                                        id="path2"
                                                                        // ref={this.fileInputRef}
                                                                        name='path2'
                                                                        className="image-upload"
                                                                        accept=".jpg, .jpeg, .png, .pdf"
                                                                        onChange={e => this.onFilePick(e, e.target.files, 2)}
                                                                    // disabled={isView}
                                                                    />
                                                                    {
                                                                        devAsItemFile != "" &&
                                                                        <i class="fa fa-times text-danger img-can"
                                                                            onClick={() => this.onCrossClick(2)}
                                                                        ></i>
                                                                    }
                                                                </label>
                                                            </div>}
                                                        {
                                                            <span className="text-danger text-start text-left d-block mt-1">
                                                                {this.state.devAsItemErr}
                                                            </span>
                                                        }
                                                    </div>
                                                </>
                                                }
                                            </div> : <></>
                                    }

                                </>
                                    : <table class="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0 " >
                                        <thead class="table-light">
                                            <tr>
                                                {/* <th className="text-center">Role ID</th> */}
                                                <th className="text-center">Sr no.</th>
                                                <th className="text-center">Sponsorship type</th>
                                                <th className="text-center">Total Qty</th>
                                                <th className="text-center">Amount INR</th>
                                                <th className="text-center">Amount USD</th>
                                                <th className="text-center">Available Qty</th>
                                                <th className="text-center">User</th>
                                                {/* <th className="text-center">Deliverable</th> */}
                                                <th className="text-center">Status</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                sponsorShipList.length > 0 ? <>{
                                                    sponsorShipList.map((data, i) => (
                                                        <tr key={Math.random()}>
                                                            {/* <td className="text-center">{data.RoleID}</td> */}
                                                            <td className="text-center">{i + 1}</td>
                                                            <td className="text-center">{data.SponsorshipTypeName} </td>
                                                            <td className="text-center">{data.TotalQty} </td>
                                                            <td className="text-center">{data.AmountINR != null && data.AmountINR != '' ? data.AmountINR.toLocaleString("en-IN") : '-'}</td>
                                                            <td className="text-center">{data.AmountUSD != null && data.AmountUSD != '' ? data.AmountUSD.toLocaleString("en-IN") : '-'}</td>
                                                            <td className="text-center">{data.AvailableQty}</td>
                                                            <td className="text-center">{data.IsShowToExhibitor && data.IsShowToVisitor ? "Exhibitor, Visitor" : data.IsShowToExhibitor ? "Exhibitor" : "Visitor"}</td>
                                                            {/* <td className="text-center">{data.IsDeliverableAsPDF ? "Pdf" : "Item"}</td> */}
                                                            <td className="text-center">{data.SponsorshipStatusName}</td>
                                                            <td className="text-center">
                                                                <i className="fa fa-pencil grid-icon border-end pe-2 me-2" aria-hidden="true"
                                                                    // onClick={(e) => this.handleUpdate(data.AccountID)}
                                                                    onClick={e => this.setState({ isAU: true, SponsorshipHdrID: data.SponsorshipHdrID, sponsorshipTypeId: data.SponsorshipTypeID }, () => {
                                                                        this.getSponsershipMasterDetails()
                                                                    })}
                                                                />

                                                                {/* </td> */}
                                                                {/* <td className="text-center"> */}
                                                                <i className="fa fa-trash text-danger" aria-hidden="true"
                                                                    // onClick={(e) => this.onDelete(data.AccountID)}
                                                                    onClick={(e) => this.onDelete(data.SponsorshipHdrID)}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </> :
                                                    <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                            }
                                        </tbody>
                                    </table>}
                            </div>
                            {/* <div class="col-md-12"> */}
                            {isAU && <div className="col-md-3 mt-4 ms-2">
                                <div className="switch-container">
                                    <label className={this.state.status ? "active" : ""}>
                                        <input
                                            type="radio"
                                            name="switch"
                                            value={status}
                                            checked={this.state.status}
                                            onChange={() => this.setState({ status: true })}
                                        />
                                        Available
                                    </label>

                                    <label className={!this.state.status ? "active" : ""}>
                                        <input
                                            type="radio"
                                            name="switch"
                                            value={!status}
                                            checked={!this.state.status}
                                            onChange={() => this.setState({ status: false })}
                                        />
                                        Sold
                                    </label>
                                </div>
                            </div>}
                            {isAU && <button type="button" class="btn btn-aqua rounded-1 mt-4 mx-2" style={{ float: 'right' }}
                                onClick={(e) => this.setState({ isAU: false })}>
                                Back
                            </button>}
                            {isAU && <button type="button" class="btn btn-aqua rounded-1 mt-4" style={{ float: 'right' }}
                                onClick={(e) => this.insertUpdateSponsorshipMaster()}>
                                Save
                            </button>}
                            {/* </div> */}
                        </div>
                    </div>

                </>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                <h5 class="modal-title">Do you really want to delete this record?</h5>

                                {/* <button type="button " class="close pop-close" data-dismiss="modal"
                                        onClick={() => this.setState({ isOpen: false })}
                                    ><span aria-hidden="true" class="pop-cancel">&times;</span></button> */}
                            </div>
                            {/* <div class="modal-body">
                                    <div class="row">
                                    </div>
                                </div> */}
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop"
                                        onClick={(e) => this.deleteSponsorshipMaster(this.state.deleteID)}
                                    >Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen: false, deleteID: '' })}
                                    >No</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal>
            </>
        );
    }
}

export default withRouter(connect(null, { fill_action, getSponsershipDetails_action, deleteSponsorshipMaster_action, insertUpdateSponsorshipMaster_action, getSponsorshipMasterDetails_action })(SponsorshipMaster));